import React from 'react';

import { ProjectSpatialReferenceContext } from '../../project-reference-state';
import { setProjectReferenceSnapshot } from './project-reference-adapter.internal';
import type { ProjectReferenceSnapshot } from './project-reference-adapter.shared';

const EMPTY_SNAPSHOT: ProjectReferenceSnapshot = Object.freeze({});

/**
 * Renders nothing. Subscribes to ProjectSpatialReferenceContext and pushes a read-only
 * snapshot into projectReferenceAdapter so non-React code (viewer, gcp-parser, etc.)
 * can read coordinateSystem/geoid without touching React. Must be mounted inside
 * ProjectSpatialReferenceContext.Provider.
 *
 * Sync is done in useEffect (not during render) to keep render pure and avoid issues
 * with StrictMode, Concurrent Mode, and SSR. Non-React consumers read the adapter
 * from effects/callbacks, so updating after commit is safe.
 */
export function ProjectReferenceAdapterBridge() {
  const ctx = React.useContext(ProjectSpatialReferenceContext);
  const coordinateSystem = ctx?.coordinateSystem;
  const geoid = ctx?.geoid;

  React.useEffect(() => {
    const snap: ProjectReferenceSnapshot = Object.freeze({
      coordinateSystem,
      geoid,
    });
    setProjectReferenceSnapshot(snap);
    return () => setProjectReferenceSnapshot(EMPTY_SNAPSHOT);
  }, [coordinateSystem, geoid]);

  return null;
}
